import { useTimeAgo } from '@/commons/timeAgo';
import { Badge, Flex, Text } from '@mantine/core';
import { useIntl } from 'react-intl';
import { Folder } from '../types';

interface FolderHeaderProps {
  folder: Folder;
}

export const FolderHeader = ({ folder }: FolderHeaderProps) => {
  const intl = useIntl();
  const timeAgo = useTimeAgo();

  return (
    <Flex direction="row" gap="xs" align="center" justify="space-between">
      <Flex direction="row" gap="xs" align="center">
        <Badge variant="light" color="blue" size="sm">
          {folder.category}
        </Badge>

        <Text fz="xs" fw={500}>
          {folder.folderName}
        </Text>

        <Text size="xs" c="dimmed">
          {intl.formatMessage({ id: 'updatedAt' })}{' '}
          {timeAgo.format(new Date(folder.updatedAt))}
        </Text>
      </Flex>

      <Flex direction="row" gap="xs" align="center">
        <Text size="xs" c="dimmed">
          {intl.formatMessage({ id: 'added' })}{' '}
          {timeAgo.format(new Date(folder.createdAt))}
        </Text>
      </Flex>
    </Flex>
  );
};
